export default __webpack_public_path__ + "static/media/pnsv_stand_Cemex.d9835898.png";